<template>
  <v-card class="idcs-main-back">
    <v-card-subtitle>
      <v-btn icon class="mr-4" @click="printPage">
        <v-icon>mdi-printer</v-icon>
      </v-btn>
      <span class="d-inline-block mr-5">
        <v-icon color="white" class="idcs-t-sell idcs-legend-icon mr-2">fa-shopping-cart</v-icon>
        <span>{{ $t("card.legend.purchase."+$store.getters.iface) }}</span>
      </span>
      <span class="d-inline-block mr-5">
        <v-icon color="white" class="idcs-t-buy idcs-legend-icon mr-2">fa-money-bill-wave</v-icon>
        <span>{{ $t("card.legend.sell."+$store.getters.iface) }}</span>
      </span>
      <span class="d-inline-block mr-5">
        <v-icon color="white" class="idcs-t-info idcs-legend-icon mr-2">fa-info</v-icon>
        <span>{{ $t("card.legend.info") }}</span>
      </span>
      <span class="d-inline-block mr-5">
        <v-icon color="white" class="idcs-t-error idcs-legend-icon mr-2">fa-bug</v-icon>
        <span>{{ $t("card.legend.error") }}</span>
      </span>
      <span class="d-inline-block mr-5">
        <v-icon color="white" class="idcs-t-reversal idcs-legend-icon mr-2">fa-times-circle</v-icon>
        <span>{{ $t("card.legend.reversal") }}</span>
      </span>
    </v-card-subtitle>
    <v-card-text>
      <v-simple-table :fixed-header="true">
        <table>
          <thead>
            <tr>
              <th class="idcs-th-back"></th>
              <th class="idcs-th-back">#</th>
              <template v-for="col in columns">
                <th :class="'idcs-th-back text-' + col.align" :key="col.value">{{ $t(col.name) }}</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in items" :key="item.id">
              <td class="idcs-th-back" align="center">
                <v-icon dark :class="'idcs-legend-icon ' + tdClass(item)" v-text="rowIcon(item)"></v-icon>
              </td>
              <td :class="tdClass(item)">{{ i+1 }}</td>
              <template v-for="col in columns">
                <td
                  v-if="col.value == 'p2'"
                  :key="col.value"
                  :align="col.align"
                  :class="tdClass(item)"
                >{{ item.command == 1300 ? item[col.value] : autoformat(col.filter, item[col.value]) }}</td>
                <td
                  v-else
                  :key="col.value"
                  :align="col.align"
                  :class="tdClass(item)"
                >{{ autoformat(col.filter, item[col.value], item) }}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import app from "@/app.js";
export default {
  name: "CardLogsTable",
  props: {
    items: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    columns: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    reverse: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    printPage() {
      let headers = {
        title: this.$t("report.title.trans"),
        created: new Date().toString(),
        filter: {
          card: this.items[0].card
        }
      };
      let footers = { totals: {} };
      this.columns.forEach(e => {
        e.text = this.$t(e.name);
      });
      app.generatePrintPage(
        { items: this.items },
        this.columns,
        headers,
        footers
      );
    },
    rowIcon(i) {
      try {
        if (i.code != 0) return "fa-bug";
        if (i.command == 1300) return "fa-times-circle";
        if (i.command == 1200) {
          if (this.reverse)
            return i.p1 ? "fa-shopping-cart " : "fa-money-bill-wave ";
          return i.p1 ? "fa-money-bill-wave " : "fa-shopping-cart ";
        }
        if (i.command == 1100) return "fa-info";
      } catch (e) {
        console.log(e.message);
      }
    },
    tdClass(i) {
      let cls = "idcs-t-";
      if (i.code != "0") return (cls += "error");
      if (i.command == 1300) return (cls += "reversal");
      if (i.command == 1200) {
        if (this.reverse) return i.p1 ? "idcs-t-sell " : "idcs-t-buy ";
        return i.p1 ? "idcs-t-buy " : "idcs-t-sell ";
      }
      if (i.command == 1100) return (cls += "info");
      return cls;
    },
    autoformat(filter, val, item) {
      if (filter == "dt-only") return this.$options.filters["dt-only"](val);
      if (filter == "dt-time") return this.$options.filters["dt-time"](val);
      if (filter == "currency") return this.$options.filters.currency(val);
      if (filter == "command") {
        if (val != 1200) return this.$t("card.command." + val);
        return this.$t(
          "card.command." +
            val +
            (item.p1 != 0) +
            "." +
            this.$store.getters.iface
        );
      }
      return val;
    }
  }
};
</script>
<style lang="scss" scoped></style>
